import type { Types } from '@amplitude/analytics-browser'

import { startAmplitudeIfConsented } from './amplitude'
import { resolvePathname, routeContextOf } from './pageContext'

// Tags every outgoing event with the current route's page_type, its portal (flow_origin: original / b2b) and its IDs:
// the original portal's under the legacy keys (workspace_id / scenario_id / session_id / template_id), a B2B session as
// b2b_session_id. Derived from the current URL so call sites never thread these through track(). The URL is the source of truth React
// Router also reads; the route table (paths.ts) supplies each route's page_type.
//
// Intentional asymmetry — do NOT "make consistent": IDs are spread AFTER existing props
// (route wins, matching the previous plugin), while page_type is only filled when ABSENT
// so an explicit page_type passed by a call site wins.
const routeContextPlugin: Types.EnrichmentPlugin = {
  name: 'np-route-context',
  type: 'enrichment',
  execute: event => {
    // event_properties is `{ [key: string]: any } | RevenueEventProperties`; copy into a
    // plain record so we can read/spread page_type without tripping the union.
    const props: Record<string, unknown> = { ...event.event_properties }
    const { pathname } = window.location
    const { pageType, params } = resolvePathname(pathname)
    event.event_properties = {
      ...props,
      ...routeContextOf(pathname, params),
      ...(typeof props.page_type === 'undefined' && typeof pageType !== 'undefined' ? { page_type: pageType } : {}),
    }
    return Promise.resolve(event)
  },
}

// Called at boot (`main.tsx`) and again on a consent grant (`CookieConsentProvider`); takes no
// arguments so those two cannot drift. Outside amplitude.ts to keep react-router off /mcp-connect.
export function initAmplitudeIfAllowed(): void {
  startAmplitudeIfConsented({ enrichmentPlugins: [routeContextPlugin], recordSessionReplay: true })
}
